import React from "react";
import { Moon, Sun, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/lib/theme";

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-jost font-semibold tracking-tight lowercase ${className}`}>
      gigazip<span className="text-sky-300"> splitbill</span>
    </span>
  );
}

export function Header({ title, subtitle, back = false, right = null }) {
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  return (
    <div className="relative bg-[var(--gz-header)] text-white gz-noise">
      <div className="max-w-md mx-auto gz-safe-top pb-24 px-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 min-w-0">
          {back && (
            <button
              data-testid="header-back-btn"
              onClick={() => navigate("/")}
              className="grid place-items-center h-10 w-10 -ml-2 rounded-full hover:bg-white/10 active:scale-90 transition-transform"
              aria-label="Back to home"
            >
              <ArrowLeft size={20} />
            </button>
          )}
          <Wordmark className="text-lg" />
        </div>
        <div className="flex items-center gap-1">
          {right}
          <button
            data-testid="theme-toggle-btn"
            onClick={toggle}
            className="grid place-items-center h-10 w-10 rounded-full hover:bg-white/10 active:scale-90 transition-transform"
            aria-label="Toggle dark mode"
          >
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
        </div>
      </div>
      {title && (
        <div className="mt-6">
          <h1 className="text-2xl font-semibold tracking-tight" data-testid="header-title">
            {title}
          </h1>
          {subtitle && <p className="text-sm text-white/60 mt-1">{subtitle}</p>}
        </div>
      )}
      </div>
    </div>
  );
}
